import { render, staticRenderFns } from "./ProfitStatistics2.vue?vue&type=template&id=3a550b1a&scoped=true&"
import script from "./ProfitStatistics2.vue?vue&type=script&lang=js&"
export * from "./ProfitStatistics2.vue?vue&type=script&lang=js&"
import style0 from "./ProfitStatistics2.vue?vue&type=style&index=0&id=3a550b1a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a550b1a",
  null
  
)

export default component.exports